import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OtpInputComponent } from './otp-input/otp-input.component';
import { UtilsService } from 'src/app/services/utils.service';
import { maskPhoneNumber } from '../../utils/phone-utils';
import { config as countryConfig } from 'src/app/config/country-config';
import { AppCountry } from 'src/app/app.models';
import { Subject } from 'rxjs';


@Component({
    selector: 'app-submit-otp',
    templateUrl: './submit-otp.component.html',
    styleUrls: ['./submit-otp.component.scss'],
    standalone: false
})
export class SubmitOtpComponent {
  @ViewChild('otpInputComponent') public otpInputComponent: OtpInputComponent;

  private _phoneNumber: string;
  @Input() set phoneNumber(phoneNumber: string | null) {
    this._phoneNumber = !!phoneNumber ? phoneNumber : '';
    this.formatAndMaskPhoneNumber();
  };
  public get phoneNumber() {
    return this._phoneNumber;
  }

  private _dialCode: string;
  @Input() set dialCode(dialCode: string | null) {
    this._dialCode = !!dialCode ? dialCode : '';
    this.formatAndMaskPhoneNumber();
  };
  public get dialCode() {
    return this._dialCode;
  }

  private _iso2Code: string;
  @Input() set iso2Code(iso2Code: string | null) {
    this._iso2Code = !!iso2Code ? iso2Code : '';
    this.formatAndMaskPhoneNumber();
  };
  public get iso2Code() {
    return this._iso2Code;
  }

  private _initialCountdownInSeconds: number;
  @Input() set initialCountdownInSeconds(resetOtpTimerInSec: number) {
    if (!resetOtpTimerInSec || resetOtpTimerInSec === 0) {
      this._initialCountdownInSeconds = 120;
    }
    else {
      this._initialCountdownInSeconds = resetOtpTimerInSec;
    }
  }
  public get initialCountdownInSeconds() {
    return this._initialCountdownInSeconds;
  }

  @Input() cmsLabels: any // Todo: Tim: fix types

  public displayPhoneNumber: string = '';
  public countryList: AppCountry[] = countryConfig;
  public isResetButtonDisabled: boolean = false;

  public timerClickSubject: Subject<string> = new Subject();

  @Output() submitOtpEvent = new EventEmitter<string>();
  @Output() requestNewOtpEvent = new EventEmitter<void>();

  constructor(public utilsService: UtilsService) {}

  submitOtp(otp: string): void {
    this.submitOtpEvent.emit(otp);
  }

  private formatAndMaskPhoneNumber() {
    if (
      !!this.phoneNumber &&
      // !!this.iso2Code &&
      !!this.dialCode
    ) {
      const iso2Code = !!this.iso2Code ? this.iso2Code : this.findISO2CodeByDialCode(this.countryList, this.dialCode);
      const formattedNumber = this.utilsService.formatPhoneNumber(this.phoneNumber, iso2Code);
      this.displayPhoneNumber = '+' + this.dialCode + ' ' + maskPhoneNumber(formattedNumber);
    }
  }

  // Todo: Tim: this is a temporary solution for when the iso2code is not provided by the SAS endpoint for phone lookup by wallet
  // Todo: Tim: this is a pure function, we can move to a utils file if this may get reused
  private findISO2CodeByDialCode(countryList: AppCountry[], dialCode: string | null) {
    let country = countryList.find(({ countryDialingCode }) => countryDialingCode.toString() === dialCode?.toString()) || null;
    return country?.iso2Code ?? 'US';
  }

  requestNewOtpCode() {
    console.log('CLICKED Request new OTP'); // Todo: Remove:
    // TODO: TIM: Add logic to submit request a new OTP sent to user's phone
    this.requestNewOtpEvent.emit();
    this.timerClickSubject.next('start');
    this.isResetButtonDisabled = true;
    setTimeout(() => {
      this.isResetButtonDisabled = false;
      this.timerClickSubject.next('reset');
    }, this.initialCountdownInSeconds * 1000)
  }

  resetOtpForm(): void {
    this.otpInputComponent.resetOtpForm();
  }

  getPhoneLabel(cmsLabel: string, phoneNumber: string): string {
    return cmsLabel.replace('%s', phoneNumber)
  }
}
